import script from "./ProgrammeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgrammeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProgrammeDetail.vue?vue&type=style&index=0&id=4af6eb9f&lang=less&scoped=true"
script.__scopeId = "data-v-4af6eb9f"

export default script